export default "__VITE_ASSET__c1b5cf83__"